import { ViewRulesetsPage } from "./ViewRulesetsPage";

export default ViewRulesetsPage;
